(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3492],{

/***/ 91606:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publish",
      function () {
        return __webpack_require__(70132);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SiteBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86542);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76195);
/* harmony import */ var datocms_structured_text_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62338);



function SiteBanner(param) {
    var content = param.content, enabled = param.enabled;
    return enabled && !(0,datocms_structured_text_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEmptyDocument */ .RL)(content) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-stealth-bomber text-white px-7 py-4 flex justify-center text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_2__/* .StructuredText */ .rZ, {
            data: content,
            customMarkRules: [
                (0,react_datocms__WEBPACK_IMPORTED_MODULE_3__/* .renderMarkRule */ .zf)("strong", function(param) {
                    var children = param.children, key = param.key;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        className: "font-medium",
                        children: children
                    }, key);
                }), 
            ]
        })
    }) : null;
}



/***/ }),

/***/ 70132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ publish; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/useQuerySubscription/index.js + 2 modules
var useQuerySubscription = __webpack_require__(63430);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/Seo/renderMetaTags.js
var renderMetaTags = __webpack_require__(12569);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/index.ts + 103 modules
var components = __webpack_require__(80338);
// EXTERNAL MODULE: ./src/components/lifetime-deal/DealOfLifeTimeBanner.tsx + 1 modules
var DealOfLifeTimeBanner = __webpack_require__(80411);
// EXTERNAL MODULE: ./src/config/index.ts + 4 modules
var config = __webpack_require__(26499);
;// CONCATENATED MODULE: ./public/images/flothemes.png
/* harmony default export */ var flothemes = ({"src":"/_next/static/media/flothemes.d118c851.png","height":65,"width":276,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAACVBMVEUcHh4TFhgSFBat0ORSAAAAA3RSTlM0RlVkNsRqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAFklEQVR4nGNgYGAEQwYGJiYGJkYmBgAAYgANy937HwAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./public/images/fstoppers.png
var fstoppers = __webpack_require__(91025);
;// CONCATENATED MODULE: ./public/images/photobiz-xposed.png
/* harmony default export */ var photobiz_xposed = ({"src":"/_next/static/media/photobiz-xposed.ad280832.png","height":88,"width":394,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAABlBMVEUJCQkPDw/uC4OfAAAAAnRSTlMlMc++HeUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAXSURBVHicY2BgYGBgZGAEUQyMjIyMDAAAOAAH/QSDYgAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./public/images/shotkit.png
var shotkit = __webpack_require__(81545);
// EXTERNAL MODULE: ./public/images/slr-lounge.png
var slr_lounge = __webpack_require__(57279);
;// CONCATENATED MODULE: ./public/images/tribe-archipelago.png
/* harmony default export */ var tribe_archipelago = ({"src":"/_next/static/media/tribe-archipelago.6ea80ac6.png","height":220,"width":220,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEWBgYF6enpAQEBlZWV+fn5mZmZxcXFLS0s8PDw6tsQtAAAACXRSTlMBDmEjGzwtR25VBgy9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nB3KsREAQQjDQGFjoP+Kf+4jbSCgZxqgZnbrYe9kI0mnE95N0gVV7jbQSeafXS8fHfoAwiaGBHEAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/modules/index.ts + 42 modules
var modules = __webpack_require__(88038);
// EXTERNAL MODULE: ./src/modules/site-banner.tsx
var site_banner = __webpack_require__(6985);
// EXTERNAL MODULE: ./src/utils/index.ts + 7 modules
var utils = __webpack_require__(20978);
// EXTERNAL MODULE: ./node_modules/@narrative-software/narrative-web-ui/dist/index.js
var dist = __webpack_require__(67199);
;// CONCATENATED MODULE: ./src/pages/publish/index.tsx



















var COMPANY_LOGOS = [
    {
        src: fstoppers/* default */.Z,
        width: 155,
        height: 42,
        companyName: "Fstoppers"
    },
    {
        src: flothemes,
        width: 154,
        height: 36,
        companyName: "Flothemes"
    },
    {
        src: shotkit/* default */.Z,
        width: 140,
        height: 40,
        companyName: "ShotKit"
    },
    {
        src: photobiz_xposed,
        width: 197,
        height: 44,
        companyName: "Photobiz Xposed"
    },
    {
        src: tribe_archipelago,
        width: 121,
        height: 121,
        companyName: "Tribe Archipelago",
        className: "lg:-my-8"
    },
    {
        src: slr_lounge/* default */.Z,
        width: 136,
        height: 53,
        companyName: "SLR Lounge"
    }, 
];
var THREE_UP_DATA = [
    {
        title: "Integrate with your website",
        description: "Use our custom integrations with Wordpress, WIX and Squarespace. With someone else? We still work with any website.",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/images/integration-logos.png",
            alt: "",
            width: "225",
            height: "38"
        }),
        imageHeight: 38
    },
    {
        title: "Easy to use, easy on the eye",
        description: "Publish is easy to use and easy on the eye. It’s also quick to learn with our intuitive controls and in-built guidance.",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/images/heart-eyes.svg",
            alt: "",
            width: "32",
            height: "31",
            unoptimized: true
        }),
        imageHeight: 31
    },
    {
        title: "Super-fast loading",
        description: "Publish compresses and resizes your images so your content loads fast and is responsive for mobile.",
        image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/images/lightning-bolt.svg",
            alt: "",
            width: "45",
            height: "45",
            unoptimized: true
        }),
        imageHeight: 45
    }, 
];
var PublishPage = function(param) {
    var subscription = param.subscription, preview = param.preview;
    var ref = (0,useQuerySubscription/* useQuerySubscription */.L)(subscription), tmp = ref.data, ref1 = tmp === void 0 ? {} : tmp, data = ref1.page, banner = ref1.banner;
    if (!data) return null;
    var testimonials = data.testimonials, seo = data.seo, stats = data.stats, dealBanner = data.dealBanner;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Layout */.Ar, {
        product: "publish",
        preview: preview,
        siteBanner: banner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(site_banner/* SiteBanner */.b, (0,_object_spread/* default */.Z)({}, banner)) : null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SEO */.HJ, {
                children: (0,renderMetaTags/* renderMetaTags */.y)(seo)
            }),
            (0,utils/* isSaleActive */.xW)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* HeroSectionSale */.VV, {
                product: "publish",
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Tell your photography stories, ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                            children: "up to 50% OFF"
                        })
                    ]
                }),
                videoSrc: "/videos/publish-video.webm",
                videoPoster: "/images/publish-video-placeholder-hero.jpg",
                videoAspectRatio: 720 / 416,
                companyLogos: COMPANY_LOGOS,
                companyLogosLabel: "As seen in:",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Publish enables photographers to create beautiful, SEO optimised blog posts in minutes –",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: "and it’s now up to 50% off for Black Friday!"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* HeroSection */.DH, {
                product: "publish",
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                            children: "Effortlessly"
                        }),
                        " tell your photography stories."
                    ]
                }),
                videoSrc: "/videos/publish-video.webm",
                videoPoster: "/images/publish-video-placeholder-hero.jpg",
                videoAspectRatio: 720 / 416,
                videoControls: true,
                children: "Publish enables photographers to create beautiful, SEO optimised blog posts in minutes."
            }),
            stats ? /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Stat */.kN, (0,_object_spread/* default */.Z)({}, stats)) : null,
            dealBanner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DealOfLifeTimeBanner/* default */.Z, (0,_object_spread/* default */.Z)({}, dealBanner)) : null,
            testimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Carousel */.lr, (0,_object_spread/* default */.Z)({}, testimonials)),
            (0,utils/* isSaleActive */.xW)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MidPromoSaleBanner */.xq, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PromoBanner, {
                title: "Join thousands of photographers blogging with Publish",
                description: "Get started with Publish for free on macOS.",
                backgroundImagePath: "/images/textures/pink-bg-alt@2x.png",
                form: config/* IS_GOOGLE_AUTH_ENABLED */.Hw ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* StartFreeButtons */.zH, {
                    product: "publish",
                    className: "max-w-130"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SignUpForm */.WS, {
                    product: "publish",
                    className: "max-w-160",
                    textClassName: "text-white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-col items-center py-12 px-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CredibilityBar */.KW, {
                        logos: COMPANY_LOGOS,
                        label: "As seen in:"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PublishVideosSection */.Iz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PublishKeyFeaturesSection */.RR, {
                "py-4812": true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
                className: "flex-col self-center items-center w-full max-w-7xl -mt-10 lg:-mt-18 xl:-mt-36",
                addXPadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ThreeUp, {
                    children: THREE_UP_DATA.map(function(_param) /*#__PURE__*/ {
                        var title = _param.title, description = _param.description, rest = (0,_object_without_properties/* default */.Z)(_param, [
                            "title",
                            "description"
                        ]);
                        return (0,jsx_runtime.jsx)(dist.ThreeUp.Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            title: title
                        }, rest), {
                            children: description
                        }), title);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PublishWorkflowSection */.s8, {}),
            (0,utils/* isSaleActive */.xW)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BottomPromoSaleBanner */.jU, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PromoBanner, {
                title: "Build beautiful blogs with Publish",
                description: "Get started with Publish for free on macOS.",
                form: config/* IS_GOOGLE_AUTH_ENABLED */.Hw ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* StartFreeButtons */.zH, {
                    product: "publish",
                    className: "max-w-130"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SignUpForm */.WS, {
                    product: "publish",
                    className: "max-w-160",
                    textClassName: "text-white"
                }),
                backgroundImagePath: "/images/textures/pink-bg@2x.png",
                imageAlignment: "left",
                large: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CustomerCareSection */.CF, {
                product: "publish"
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var publish = (PublishPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(91606); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);